export default __webpack_public_path__ + "static/media/seasoning.722715ff.png";